<template>
    <div>
        <b-modal
            id="m-approval"
            title="Input Approval"
            size="xl"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <LoadingWidget
                v-if="initStatus != 1"
                :status="initStatus"
                @init="init"
            />
            <div v-else-if="item">
                <div
                    class="d-flex justify-content-between align-items-center mb-3"
                >
                    <h5 class="mb-0">
                        Informasi Item
                    </h5>
                </div>

                <hr />

                <b-row>
                    <b-col>
                        <div class="d-flex flex-column mb-2">
                            <strong>No. Faktur</strong>
                            <span>{{ displayData.no_faktur || "-" }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>Kadar</strong>
                            <span>{{ displayData.purity || "-" }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>Berat Kotor</strong>
                            <span>{{ displayData.dry_weight || "-" }} gr</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>Berat Potongan</strong>
                            <span>{{
                                displayData.weight_reduction || "-"
                            }} gr</span>
                        </div>
                    </b-col>
                    <b-col>
                        <div class="d-flex flex-column mb-2">
                            <strong>Jenis Item</strong>
                            <span>{{ displayData.item_kind || "-" }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>Merk Item</strong>
                            <span>{{ displayData.item_brand || "-" }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>Tipe Emas</strong>
                            <span>{{ displayData.gold_type || "-" }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>Sumber</strong>
                            <span>{{ source || "-" }}</span>
                        </div>
                        <div class="d-flex flex-column w-25">
                            <strong>Status Temuan</strong>
                            <h6>
                                <b-badge
                                    :variant="
                                        getStatusBadge(
                                            displayData.approval_status
                                        )[0]
                                    "
                                    class="text-center"
                                >
                                    {{
                                        getStatusBadge(
                                            displayData.approval_status
                                        )[1]
                                    }}
                                </b-badge>
                            </h6>
                        </div>
                    </b-col>
                </b-row>

                <div v-if="isRBE" class="d-flex flex-column mb-3">
                    <strong>Karat</strong>
                    <span>{{ displayData.carat ? displayData.carat + "K" : "-" }}</span>
                </div>

                <b-button
                    v-if="mode !== 'completion'"
                    variant="danger"
                    @click="showModal()"
                >
                    <i class="fa fa-question mr-2" />Buat Temuan
                </b-button>

                <h5 class="mt-4">
                    Form Input Approval Item Box
                </h5>

                <hr />

                <!-- Jenis Emas: hanya RBE, input dari SM -->
                <b-row v-if="isRBE" class="mb-3">
                    <b-col md="6">
                        <b-form-group label-class="font-weight-bold">
                            <template #label>
                                Jenis Emas <span style="color: red;">*</span>
                                <small class="text-muted font-weight-normal ml-1">Khusus untuk pelaporan ke PEI</small>
                            </template>
                            <multiselect
                                v-model="input.goldKind"
                                :allow-empty="false"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                placeholder="-- Pilih Jenis Emas --"
                                :options="goldKinds"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Row 1: Jenis Barang + Merk Barang (non-perhiasan) / Tipe Emas (perhiasan) -->
                <b-row class="mb-3">
                    <b-col md="6">
                        <b-form-group label-class="font-weight-bold">
                            <template #label>
                                Jenis Barang <span style="color: red;">*</span>
                            </template>
                            <multiselect
                                id="jenis-barang"
                                v-model="input.kind"
                                :allow-empty="false"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                @input="fetchMerkBarang"
                                placeholder="-- Pilih Salah Satu --"
                                :options="kinds"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" v-if="!itemFlags.isPerhiasan">
                        <b-form-group label-class="font-weight-bold">
                            <template #label>
                                Merk Barang <span style="color: red;">*</span>
                            </template>
                            <multiselect
                                id="merk-barang"
                                :disabled="fetch || !input.kind"
                                v-model="input.brand"
                                :allow-empty="false"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                @input="fetchTipeBarang"
                                placeholder="-- Pilih Salah Satu --"
                                :options="brands"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" v-if="itemFlags.isPerhiasan">
                        <b-form-group label-class="font-weight-bold">
                            <template #label>
                                Tipe Emas <span style="color: red;">*</span>
                            </template>
                            <multiselect
                                :disabled="fetch"
                                v-model="input.goldType"
                                :allow-empty="false"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                placeholder="-- Pilih Salah Satu --"
                                :options="goldTypes"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Row 2: Tipe Barang (non-perhiasan) / Ada Cap + Cap (perhiasan) -->
                <b-row class="mb-3" v-if="!itemFlags.isPerhiasan && input.brand">
                    <b-col md="6">
                        <b-form-group label-class="font-weight-bold">
                            <template #label>
                                Tipe Barang <span style="color: red;">*</span>
                            </template>
                            <multiselect
                                id="tipe-barang"
                                :disabled="fetch || !input.brand"
                                v-model="input.type"
                                :allow-empty="false"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                placeholder="-- Pilih Salah Satu --"
                                :options="types"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mb-3" v-if="itemFlags.isPerhiasan">
                    <b-col md="6">
                        <b-form-group label-class="font-weight-bold">
                            <template #label>
                                Ada Cap <span style="color: red;">*</span>
                            </template>
                            <multiselect
                                v-model="input.hasMark"
                                label="name"
                                :options="optBoolean"
                                @input="onHasMarkChange"
                                placeholder="-- Pilih Salah Satu --"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" v-if="isHasMark">
                        <b-form-group label-class="font-weight-bold">
                            <template #label>
                                Cap <span style="color: red;">*</span>
                            </template>
                            <multiselect
                                :disabled="fetch"
                                v-model="input.mark"
                                :allow-empty="true"
                                label="purity"
                                track-by="id"
                                :internal-search="true"
                                placeholder="-- Pilih Salah Satu --"
                                :options="goldCarats"
                                @input="onMarkChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <hr />

                <!-- LM Scan: hanya Tahun -->
                <b-row v-if="itemFlags.isLMScan" class="mb-3">
                    <b-col md="6">
                        <b-form-group label="Tahun" label-class="font-weight-bold">
                            <b-form-select v-model="input.year" :options="yearOptions">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilih Tahun --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Non LM Scan: Kadar, Berat, Keping, Cap Getok -->
                <template v-if="!itemFlags.isLMScan">
                    <b-row class="mb-3">
                        <b-col md="6">
                            <b-form-group label-class="font-weight-bold">
                                <template #label>
                                    Kadar XRF SM <span style="color: red;">*</span>
                                </template>
                                <b-form-input
                                    id="purity"
                                    v-model="input.purity"
                                    :readonly="mode === 'completion'"
                                    :state="purityState"
                                    :tabindex="1"
                                />
                                <b-form-invalid-feedback :state="purityState">
                                    <span v-if="input.purity > 1000">Kadar tidak boleh lebih dari 1000</span>
                                    <span v-else-if="itemFlags.isLMRetro && input.purity < 850">Kadar untuk LM Retro harus berada di antara 850 dan 1000</span>
                                    <span v-else>Selisih kadar tidak boleh lebih dari {{ attr.purity_xrf_tolerance }} (Kadar PEI: {{ itemData.purity }})</span>
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label-class="font-weight-bold">
                                <template #label>
                                    Kadar Jual <span style="color: red;">*</span>
                                </template>
                                <b-form-input
                                    id="puritySell"
                                    v-model="input.puritySell"
                                    :state="puritySellState"
                                    :readonly="mode === 'completion'"
                                    :tabindex="1"
                                    :disabled="isHasMark"
                                />
                                <b-form-invalid-feedback :state="puritySellState">
                                    <span v-if="input.puritySell > 1000">Kadar tidak boleh lebih dari 1000</span>
                                    <span v-else-if="itemFlags.isLMRetro && input.puritySell < 850">Kadar untuk LM Retro harus berada di antara 850 dan 1000</span>
                                    <span v-else>Kadar Jual tidak boleh lebih rendah dari Kadar XRF</span>
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col md="6">
                            <b-form-group label-class="font-weight-bold">
                                <template #label>
                                    Berat Kotor <span style="color: red;">*</span>
                                </template>
                                <b-input-group append="gr">
                                    <b-form-input
                                        id="dryWeight"
                                        v-model="input.dryWeight"
                                        :readonly="mode === 'completion'"
                                        :state="dryWeightState"
                                        :tabindex="2"
                                    />
                                </b-input-group>
                                <b-form-invalid-feedback :state="dryWeightState">
                                    Berat Kotor selisih maksimal {{ attr.dry_weight_tolerance }} gr ke bawah dari item Box ({{ itemData.dry_weight }} gr)
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col md="6" v-if="mode === 'completion'">
                            <b-form-group label-class="font-weight-bold">
                                <template #label>
                                    Berat Potongan <span style="color: red;">*</span>
                                </template>
                                <b-input-group append="gr">
                                    <b-form-input
                                        id="weightReduction"
                                        v-model="input.weightReduction"
                                        :disabled="true"
                                        :tabindex="2"
                                    />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col md="6" v-if="input.kind && !itemFlags.isLMRetro">
                            <b-form-group label-class="font-weight-bold">
                                <template #label>
                                    Jumlah Keping <span style="color: red;">*</span>
                                </template>
                                <b-input-group append="pcs">
                                    <b-form-input
                                        id="pieceCount"
                                        v-model="input.pieceCount"
                                        :tabindex="4"
                                    />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6" v-if="itemFlags.isPerhiasan">
                            <b-form-group label-class="font-weight-bold">
                                <template #label>
                                    Cap Getok <span style="color: red;">*</span>
                                </template>
                                <multiselect
                                    class="font-weight-normal"
                                    v-model="input.isStamped"
                                    label="name"
                                    :options="optBoolean"
                                    placeholder="-- Pilih Salah Satu --"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col>
                            <p class="font-weight-bold mb-0">Berat Bersih: {{ netWeight }}</p>
                        </b-col>
                    </b-row>
                </template>

                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button
                            id="submit-button"
                            variant="primary"
                            :disabled="isSubmitting"
                            @click="approve"
                        >
                            {{
                                isSubmitting
                                    ? "Menyimpan..."
                                    : "Simpan & Approve"
                            }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-barcode-pei" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe id="barcode-iframe" :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Mini' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button id="finish-approval" variant="primary" @click="finishApproval">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { GOLD_KIND_OPTIONS } from "@/shared/gold-kinds";

export default {
    name: "ModalApproval",
    props: {
        item: {
            type: Object,
            default: () => null
        },
        noFaktur: {
            type: String,
            default: ""
        },
        mode: {
            type: String,
            default: "approval"
        },
        action: {
            type: String,
            default: null
        },
        submitUrl: {
            type: String,
            default: null
        },
        attr: {
            type: Object,
            default: () => null
        },
        source: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            itemData: {},
            initStatus: 0,
            isSubmitting: false,
            input: {
                kind: null,
                brand: null,
                type: null,
                purity: null,
                puritySell: null,
                dryWeight: null,
                weightReduction: null,
                goldType: null,
                goldKind: null,
                pieceCount: null,
                hasMark: null,
                mark: null,
                isStamped: null,
                year: null,
                photos: []
            },
            goldKinds: GOLD_KIND_OPTIONS,
            optBoolean: [
                { value: true, name: "Ada" },
                { value: false, name: "Tidak Ada" }
            ],
            kinds: [],
            brands: [],
            types: [],
            goldTypes: [],
            goldCarats: [],
            fetch: false,

            barcodeLink: null,
            barcodeLinkMini: null,
            barcodeType: 'barcode',
            barcodeToggleCooldown: false,
        };
    },
    computed: {
        yearOptions() {
            const current = new Date().getFullYear();
            const years = [];
            for (let y = current; y >= 2000; y--) {
                years.push(String(y));
            }
            return years;
        },
        displayData() {
            if (this.mode === "completion") {
                const origin = this.item.origin_item;
                const variance = this.item.variance;
                return {
                    no_faktur: origin.no_faktur,
                    purity: origin.purity,
                    purity_sell: origin.purity_sell,
                    dry_weight: origin.dry_weight,
                    weight_reduction: origin.weight_reduction,
                    item_kind: origin.item_kind,
                    item_brand: origin.item_brand,
                    gold_type: origin.gold_type,
                    carat: origin.carat,
                    approval_status: this.item.status,
                    final_purity: variance.final_purity,
                    final_dry_weight: variance.final_dry_weight,
                    final_weight_reduction: variance.final_weight_reduction
                };
            }
            return this.item && this.item.item ? this.item.item : {};
        },
        isRBE() {
            return this.source === "RBE";
        },
        itemFlags() {
            return {
                isLMRetro: this.input.kind && this.input.kind.id === 261,
                isLMScan: this.input.kind && this.input.kind.id === 251,
                isPerhiasan: this.input.kind && this.input.kind.id === 257
            };
        },
        netWeight() {
            const reduction = this.mode === 'completion' && this.input.weightReduction
                ? this.input.weightReduction
                : (this.displayData.weight_reduction || 0);

            return `${(this.input.dryWeight - reduction).toFixed(2)} gr`;
        },
        purityState() {
            if (!this.itemData || this.itemData.purity == null) return null;
            if (this.input.purity === null || this.input.purity === "") return null;
            if (this.input.purity > 1000) return false;
            if (this.itemFlags.isLMRetro && this.input.purity < 850) return false;
            if (this.attr.purity_xrf_tolerance == null) return null;
            return (
                this.attr.purity_xrf_tolerance >=
                Number(this.itemData.purity) - Number(this.input.purity)
            );
        },
        puritySellState() {
            if (this.input.puritySell === null || this.input.puritySell === "")
                return null;
            if (this.input.puritySell > 1000) return false;
            if (this.itemFlags.isLMRetro && this.input.puritySell < 850)
                return false;
            if (this.input.purity === null || this.input.purity === "")
                return null;

            return Number(this.input.puritySell) >= Number(this.input.purity);
        },
        dryWeightState() {
            if (!this.itemData || this.itemData.dry_weight == null) return null;
            if (!this.input.dryWeight) return null;

            const itemWeight = Number(this.itemData.dry_weight);
            const inputWeight = Number(this.input.dryWeight);
            const validDryWeight = inputWeight >= (itemWeight - this.attr.dry_weight_tolerance);

            return validDryWeight;
        },
        isHasMark() {
            return this.input.hasMark && this.input.hasMark.value === true;
        }
    },
    methods: {
        onHasMarkChange(val) {
            if (!val || val.value === false || val.value === true) {
                this.input.mark = null;
                this.input.puritySell = this.input.purity;
            }
        },
        onMarkChange(val) {
            if (val && val.purity !== null && val.purity !== undefined) {
                this.input.puritySell = val.purity;
            } else {
                this.input.puritySell = null;
            }
        },
        show() {
            this.$bvModal.show("m-approval");
            this.init();
        },
        showModal() {
            this.$bvModal.show("m-buat-temuan");
        },
        async init() {
            this.initStatus = 0;
            this.clearInput();

            if (this.item) {
                this.itemData = this.item.item;
            }

            await Promise.all([
                this.fetchJenisBarang(),
                this.fetchGoldType(),
                this.fetchGoldCarats()
            ]);

            if (this.mode === "completion" && this.item) {
                await this.prefillFormCompletion();
            }

            this.initStatus = 1;
        },

        async prefillFormCompletion() {
            const origin = this.item.origin_item || {};
            const variance = this.item.variance || {};

            if (origin.item_kind) {
                const kind = this.kinds.find(k => k.name === origin.item_kind);
                if (kind) {
                    this.input.kind = kind;
                    await this.fetchMerkBarang();
                }
            }

            if (this.input.kind && origin.item_brand) {
                const brand = this.brands.find(
                    b => b.name === origin.item_brand
                );
                if (brand) {
                    this.input.brand = brand;
                    await this.fetchTipeBarang();
                }
            }

            if (this.input.brand && origin.item_type) {
                const type = this.types.find(t => t.name === origin.item_type);
                if (type) {
                    this.input.type = type;
                }
            }

            if (origin.gold_type) {
                const gType = this.goldTypes.find(
                    g => g.name === origin.gold_type
                );
                if (gType) this.input.goldType = gType;
            }

            if (
                variance.final_purity !== null &&
                variance.final_purity !== undefined
            ) {
                this.input.purity = variance.final_purity;
                this.input.puritySell = variance.final_purity;
            } else {
                this.input.purity = origin.purity;
            }

            if (variance.final_dry_weight != null) {
                this.input.dryWeight = variance.final_dry_weight;
            }

            if (variance.final_weight_reduction != null) {
                this.input.weightReduction = variance.final_weight_reduction;
            }
        },

        async fetchJenisBarang() {
            this.input.kind = null;
            this.input.brand = null;
            this.input.type = null;
            if (this.mode !== "completion" && this.mode !== "approval") {
                this.input.purity = null;
                this.input.dryWeight = null;
            }
            this.input.goldType = null;
            this.input.pieceCount = null;

            this.fetch = true;
            await this.$axios
                .get("master/kinds?category=EMAS")
                .then(res => {
                    this.kinds = res.data.data.filter(
                        item => item.id != 246 && item.id != 252
                    );
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchMerkBarang() {
            this.input.brand = null;
            this.input.type = null;
            if (this.mode !== "completion" && this.mode !== "approval") {
                this.input.purity = null;
                this.input.dryWeight = null;
            }
            this.input.goldType = null;
            this.input.pieceCount = null;

            this.fetch = true;
            await this.$axios
                .get(`master/brands/${this.input.kind.id}`)
                .then(res => {
                    this.brands = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchTipeBarang() {
            this.input.type = null;
            if (this.mode !== "completion" && this.mode !== "approval") {
                this.input.purity = null;
                this.input.dryWeight = null;
            }
            this.input.goldType = null;
            this.input.pieceCount = null;

            this.fetch = true;
            await this.$axios
                .get(`master/types/${this.input.brand.id}`)
                .then(res => {
                    this.types = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchGoldType() {
            this.fetch = true;
            await this.$axios
                .get("master/gold-type")
                .then(res => {
                    this.goldTypes = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchGoldCarats() {
            this.fetch = true;
            await this.$axios
                .get("master/gold-carats")
                .then(res => {
                    this.goldCarats = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        getBarcodeLink() {
            if (this.barcodeType == 'mini') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkMini}`
            }
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'mini'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        showBarcode(data) {
            this.isSubmitting = false;
            this.barcodeLink = data.link;
            this.barcodeLinkMini = data.link_mini;
            this.$bvModal.hide('m-approval');
            this.$bvModal.show('m-barcode-pei');
        },

        stopLoading() {
            this.isSubmitting = false;
        },

        finishApproval() {
            this.$bvModal.hide('m-barcode-pei')
            this.$emit("approved")
        },

        async approve() {

            const modes = {
                LMScan: [
                    { key: "kind", msg: "Jenis Barang tidak boleh kosong" },
                    { key: "brand", msg: "Merk Barang tidak boleh kosong" },
                    { key: "type", msg: "Tipe Barang tidak boleh kosong" }
                ],
                LMRetro: [
                    { key: "kind", msg: "Jenis Barang tidak boleh kosong" },
                    { key: "brand", msg: "Merk Barang tidak boleh kosong" },
                    { key: "type", msg: "Tipe Barang tidak boleh kosong" },
                    { key: "purity", msg: "Kadar XRF tidak boleh kosong" },
                    { key: "puritySell", msg: "Kadar Jual tidak boleh kosong" },
                    {
                        key: "dryWeight",
                        msg: "Berat Kotor tidak boleh kosong"
                    },
                ],
                Perhiasan: [
                    { key: "kind", msg: "Jenis Barang tidak boleh kosong" },
                    { key: "hasMark", msg: "Status Cap Tanda harus dipilih" },
                    { key: "goldType", msg: "Tipe Emas tidak boleh kosong" },
                    { key: "purity", msg: "Kadar XRF tidak boleh kosong" },
                    { key: "puritySell", msg: "Kadar Jual tidak boleh kosong" },
                    {
                        key: "dryWeight",
                        msg: "Berat Kotor tidak boleh kosong"
                    },
                    {
                        key: "pieceCount",
                        msg: "Jumlah Keping tidak boleh kosong"
                    },
                    { key: "isStamped", msg: "Cap Getok harus dipilih" }
                ]
            };

            const isValidValue = val => val !== null && val !== "";
            let ruleSet = null;
            if (this.itemFlags.isLMScan) ruleSet = modes.LMScan;
            else if (this.itemFlags.isLMRetro) ruleSet = modes.LMRetro;
            else if (this.itemFlags.isPerhiasan) ruleSet = modes.Perhiasan;

            if (this.isRBE && !this.input.goldKind) {
                this.$helper.toastError(this, "Jenis Emas tidak boleh kosong");
                return;
            }

            if (!ruleSet) {
                if (!this.input.kind) {
                    this.$helper.toastError(
                        this,
                        "Jenis Barang tidak boleh kosong"
                    );
                    return;
                }
                this.$helper.toastError(this, "Jenis Barang tidak valid");
                return;
            }

            if (ruleSet) {
                for (const { key, msg } of ruleSet) {
                    const val = this.input[key];
                    if (!isValidValue(val)) {
                        this.$helper.toastError(this, msg);
                        return;
                    }
                }
            }

            if (!this.itemFlags.isLMScan && this.purityState === false) {
                const errorMsg =
                    this.input.purity > 1000
                        ? "Kadar XRF tidak boleh lebih dari 1000"
                        : this.itemFlags.isLMRetro && this.input.purity < 850
                        ? "Kadar untuk LM Retro harus berada di antara 850 dan 1000"
                        : `Selisih kadar tidak boleh lebih dari ${
                              this.attr.purity_xrf_tolerance
                          }`;
                this.$helper.toastError(this, errorMsg);
                return;
            }

            if (!this.itemFlags.isLMScan && this.puritySellState === false) {
                const errorMsg =
                    this.input.puritySell > 1000
                        ? "Kadar Jual tidak boleh lebih dari 1000"
                        : this.itemFlags.isLMRetro && this.input.puritySell < 850
                        ? "Kadar untuk LM Retro harus berada di antara 850 dan 1000"
                        : "Kadar Jual tidak boleh lebih rendah dari Kadar XRF";
                this.$helper.toastError(this, errorMsg);
                return;
            }

            if (!this.itemFlags.isLMScan) {
                const stateValidations = [
                    {
                        state: this.dryWeightState,
                        msg: "Berat Kotor selisih maksimal " + this.attr.dry_weight_tolerance + " gr ke bawah dari data emas"
                    }
                ];

                for (const { state, msg } of stateValidations) {
                    if (state === false) {
                        this.$helper.toastError(this, msg);
                        return;
                    }
                }
            }

            let confirmMessage = this.mode === 'completion'
                ? "Apakah Anda yakin akan menyelesaikan temuan ini?"
                : "Apakah Anda yakin akan menyetujui approval ini?";

            let isConfirmed = confirm(confirmMessage);

            if (isConfirmed) {
                const payload = {
                    item_kind_id: this.input.kind ? this.input.kind.id : null,
                    item_type_id: this.input.type ? this.input.type.id : null,
                    gold_type_id: this.input.goldType
                        ? this.input.goldType.id
                        : null,
                    gold_kind_id: this.isRBE && this.input.goldKind
                        ? this.input.goldKind.id
                        : null,
                    piece_count: this.input.pieceCount || null,
                    has_mark: this.input.hasMark
                        ? this.input.hasMark.value
                        : null,
                    is_stamped: this.input.isStamped
                        ? this.input.isStamped.value
                        : null,
                    year: this.input.year || null
                };

                if (!this.itemFlags.isLMScan) {
                    payload.purity_xrf = this.input.purity || null;
                    payload.purity = this.input.puritySell || null;
                    payload.dry_weight = this.input.dryWeight
                        ? parseFloat(this.input.dryWeight).toFixed(2)
                        : null;
                }

                this.isSubmitting = true;

                if (this.mode === "completion") {
                    payload.item_id = this.item.variance.origin_id;
                    payload.action = this.action;
                    this.$emit('submit-completion', payload);
                } else {
                    payload.item_id = this.item.item.id;
                    this.$emit('submit-approval', payload);
                }
            }
        },

        clearInput() {
            this.input = {
                kind: null,
                brand: null,
                type: null,
                purity: null,
                puritySell: null,
                dryWeight: null,
                weightReduction: null,
                goldType: null,
                goldKind: null,
                pieceCount: null,
                hasMark: null,
                isStamped: null,
                year: null,
                photos: []
            };
            this.itemData = {};
        },

        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return ["warning", "PENDING"];
                case 1:
                    return ["success", "APPROVED"];
                case 2:
                    return ["secondary", "PENDING AUDIT"];
                case 3:
                    return ["primary", "APPROVED AUDIT"];
                case 99:
                    return ["danger", "VARIANCE"];
                default:
                    return ["light", "-"];
            }
        }
    }
};
</script>
